import type { TrainingTemplate } from "./Training.typed";
import type { TrainingModel } from "./TrainingModel";

export class TrainingAdapter {
  private trainingModel: TrainingModel;

  constructor(trainingModel: TrainingModel) {
    this.trainingModel = trainingModel;
  }

  async getTrainingTemplateById(
    templateId: string,
    token: string,
  ): Promise<TrainingTemplate | null> {
    return this.trainingModel.getTrainingTemplateById(templateId, token);
  }
}
